const { REACT_APP_NAME } = process.env;
import { Box, Card, CardContent, CardHeader, Grid, LinearProgress, Skeleton, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetTeamsMutation } from "src/redux/api/cabinet";
import { AppState } from "src/store/Store";
import { Alerting } from "src/views/components_cabinet/Alerting"
import { PartnersContent } from "./PartnersContent";
import PageContainer from "src/components/container/PageContainer";

interface UserData {
    id: number;
    login: string;
    first_name?: string;
    last_name?: string;
    avatar?: string;
    email: string;
    phone: string;
    telegram?: string;
    vk?: string;
    whatsapp?: string;
    created_at: string;
    balance: number;
    balance_null: number;
    balance_btc?: number;
    abonent_block?: number;
    abonent_block3?: number;
    abonent_block4?: number;
    referer_id?: number;
}

interface RefererData {
    name?: string;
    login?: string;
    phone?: string;
    email?: string;
    telegram?: string;
    created_at?: string;
}

interface PartnersData {
    info: UserData;
    sponsors: any;
    teams: UserData[];
    count: number;
    referer: RefererData;
}

interface AlertState {
    type: number;
    msg: string;
}

export const PartnersOfficePage = () => {
    const { data } = useSelector((state: AppState) => state.app);
    const [alert, setAlert] = useState<AlertState | undefined>(undefined);
    const [partnersData, setPartnersData] = useState<PartnersData | undefined>(undefined);

    const [getPartnersData, { isLoading }] = useGetTeamsMutation();

    const fetchPartners = useCallback(async (userId: number) => {
        const jwt = localStorage.getItem('jwt');

        try {
            const response = await getPartnersData({
                body: { user_id: userId },
                jwt
            }).unwrap();

            setPartnersData(response.data);
        } catch (error: any) {
            setAlert({
                type: 1,
                msg: error?.data?.message || 'Ошибка загрузки данных партнеров'
            });
        }
    }, [getPartnersData]);

    const handlePartnerUpdate = useCallback((userId: number) => {
        if (userId > 0) {
            fetchPartners(userId);
        }
    }, [fetchPartners]);

    useEffect(() => {
        if (data?.id) {
            fetchPartners(data.id);
        }
    }, [data?.id, fetchPartners]);

    const SkeletonLoader = () => (
        <Box>
            <LinearProgress sx={{ mb: 3 }} />
            <Card>
                <CardHeader
                    sx={{ mb: 0, py: 0 }}
                    title={<Skeleton variant="rounded" width={210} height={30} />}
                />
                <CardContent>
                    <Grid container spacing={2} justifyContent='center' display='flex'>
                        <Grid item xs={12} display='flex' alignItems='center' flexDirection='column'>
                            <Typography variant="h5" mb={1}>
                                <Skeleton variant="rounded" width={160} height={30} />
                            </Typography>
                            <Typography sx={{ color: '#9c9c9c' }}>
                                <Skeleton variant="rounded" width={160} height={20} />
                            </Typography>
                        </Grid>
                        {[...Array(4)].map((_, index) => (
                            <Grid
                                key={index}
                                item
                                xs={6}
                                md={3}
                                display='flex'
                                alignItems='center'
                                flexDirection='column'
                            >
                                <Typography variant="h5" mb={1}>
                                    <Skeleton variant="rounded" width={160} height={30} />
                                </Typography>
                                <Typography sx={{ color: '#9c9c9c' }}>
                                    <Skeleton variant="rounded" width={160} height={20} />
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </CardContent>
            </Card>
            <Box mt={5}>
                <Skeleton variant="rounded" width="100%" height={480} />
            </Box>
        </Box>
    );

    return (
        <PageContainer title={`${REACT_APP_NAME} | Партнёры`} description="Ваши партнёры">
            <Box sx={{ my: 5 }}>
                {isLoading && <SkeletonLoader />}
                {!isLoading && partnersData && (
                    <PartnersContent
                        updPersonInfoId={handlePartnerUpdate}
                        dataArrProp={partnersData}
                    />
                )}
                {alert && <Alerting get={alert} />}
            </Box>
        </PageContainer>
    );
};